module.exports = __webpack_public_path__ + "img/logoTemplus.55a2b781.png";